import { Badge } from '@optiaxiom/react';

type StatusCellProps = {
  deactivated?: boolean;
};

export const StatusCell = ({ deactivated }: StatusCellProps) => {
  return (
    <Badge variant="subtle" intent={deactivated ? 'neutral' : 'success'}>
      {deactivated ? 'Inactive' : 'Active'}
    </Badge>
  );
};
